import { render, staticRenderFns } from "./RejectBooking.vue?vue&type=template&id=3361c572"
import script from "./RejectBooking.vue?vue&type=script&lang=js"
export * from "./RejectBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports